import { HttpService } from "./http";
import { API_BASE_URL } from "../constants/API";

const Endpoint = {
  fetchAuthorList: `${API_BASE_URL}/authors`,
};

export class AuthorService {
  /**
   * @param {{ term: string }} data
   */
  static async fetchAuthorList(data) {
    const params =
      data.term.length >= 1
        ? {
          authorName: data.term,
        }
        : {};

    const response = await HttpService.get(
      Endpoint.fetchAuthorList,
      params
    );

    return response;
  }
}

export default AuthorService;
